// extracted by mini-css-extract-plugin
export default {"manager-info-section":"uGi8KbJR4yZdMHxX159B","table-title-wrapper":"pmf59GZOgqDR3AJN7iyQ","table-title-side-field":"u3aryEb3l8b9yLKiHhPE","table-wrapper":"FUMVXT2VXL5gGv4rPnwx"};